module.exports = __webpack_public_path__ + "static/media/sketch-app-2.2f3fcfee.jpg";